import { render, staticRenderFns } from "./ApiAufruf.vue?vue&type=template&id=5b8fda57"
import script from "./ApiAufruf.vue?vue&type=script&lang=ts"
export * from "./ApiAufruf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports